import React from 'react';
import { Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import Touchable from '@src/components/Touchable';
import { H3, Subtitle2 } from '@src/components/Typography';
import useLanguage from '@src/hooks/useLanguage';
import { ImmigrationPlan } from '@src/types';

type Props = {
  active?: boolean;
  data: ImmigrationPlan;
  onPress?: () => void;
};

const PreviousAmountText = styled(Subtitle2)`
  text-decoration-line: line-through;
`;

const Container = styled.View<{ active?: boolean }>`
  overflow: hidden;
  width: 100px;
  height: 100px;
  border-radius: ${({ theme }) => theme.roundness}px;
  border: ${({ active }) => (active ? '2px' : '1px')} solid
    ${({ theme, active }) =>
      active ? theme.colors.primary : theme.colors.disabled};
  // elevation: ${({ active }) => (active ? 5 : 0)};
  shadow-color: ${({ theme }) => theme.colors.backdrop};
  shadow-offset: ${({ active }) => (active ? '0 1px' : '0 0')};
  shadow-opacity: ${({ active }) => (active ? 0.2 : 0)};
  shadow-radius: 1px;
`;

const Content = styled.View`
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const Famous = styled(H3)<{ active?: boolean }>`
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  opacity: ${({ active }) => (active ? 1 : 0)};
`;

const Component: React.FC<Props> = ({
  active,
  data: { title, previousAmountText, amountText, mostFamous },
  onPress,
}) => {
  const language = useLanguage();

  return (
    <Touchable onPress={onPress}>
      <Container active={active}>
        <Famous active={mostFamous}>
          <Trans>Favorite</Trans>
        </Famous>
        <Content>
          <H3>{title?.[language] ?? ''}</H3>
          <PreviousAmountText>
            {previousAmountText?.[language] ?? ''}
          </PreviousAmountText>
          <H3>{amountText?.[language] ?? ''}</H3>
        </Content>
      </Container>
    </Touchable>
  );
};

Component.displayName = 'Plan';

export default React.memo(Component);
